export const FALLBACK_LANGUAGE = 'ru';
export const NAME_FIRST_LANGUAGES = ['en-us', 'en-gb', 'en-ie', 'tr', 'en-ae'];
export const REACT_INTL_LOCALE_MAPPING: {
  [key: string]: string;
} = {
  de: 'de',
  es: 'es',
  fr: 'fr',
  kz: 'kk',
  pl: 'pl',
  ru: 'ru',
  tr: 'tr',
  'ru-ua': 'ru-ua',
  'uk-ua': 'uk-ua',
  'en-gb': 'en-gb',
  'en-us': 'en-us',
  'en-ch': 'en-ch',
  'en-ie': 'en-ie',
  'ru-kz': 'ru-kz',
  'ru-by': 'ru-by',
  'fr-ch': 'fr-ch',
  'de-ch': 'de-ch',
  'pt-br': 'pt-br',
  'en-ae': 'en-ae',
  'ru-us': 'ru-us',
  'ru-uz': 'ru-uz',
};
